import type { ApprovalAction } from '@cims-online/shared'
import type { WorkflowRecord } from '../../types'
import type { ApprovalActionTarget } from './types'
import { configuredFieldsRecordContext } from '../../utils/configuredFields/recordValues'

/** Captures the displayed record context when a user launches an approval action. */
export function createApprovalActionTarget(
  record: Pick<WorkflowRecord, 'id' | 'values'>,
  optionId: string,
  action: ApprovalAction
): ApprovalActionTarget {
  return {
    action,
    ...configuredFieldsRecordContext(record),
    optionId,
    optionLabel:
      Object.values(record.values)
        .flatMap((field) => (field.type === 'approvals' ? field.value : []))
        .find((option) => option.optionId === optionId)?.optionLabel ??
      'Approval option',
    recordId: record.id,
  }
}
